import React, { ReactNode } from 'react';
import { useHref } from 'react-router';

function withResolvedHref<T extends { to?: string }>(WrappedComponent: React.ComponentType<T>) {
    return function ComponentWithResolvedHref(props: T): ReactNode {
        const { to, ...rest } = props;
        const href = useHref(to ?? '');

        // since we can't conditionally use the useHref hook, we conditionally pass the result
        const conditionalHref = to ? href : undefined;

        return <WrappedComponent {...(rest as T)} to={conditionalHref} />;
    };
}

export { withResolvedHref };
